/* eslint-disable no-console */
import {
  StyleSheet, Text, View, Pressable, ScrollView, TouchableOpacity, TextInput,
} from 'react-native';
import React, { useState, useCallback } from 'react';
import {
  GiftedChat, Avatar, InputToolbar, Composer, Send,
} from 'react-native-gifted-chat';
import { FontAwesome } from '@expo/vector-icons';
import { TypingAnimation } from 'react-native-typing-animation';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Colors from '../constants/Colors';
import CompareLineGraphWeb from '../graphs/CompareLineGraphWeb';
import BarWithLineGraphWeb from '../graphs/BarWithLineGraphWeb';
import { RootTabScreenProps } from '../types';
import BackArrow from '../components/BackIcon';
import BotIcon from '../components/24pxIcons/BotIcon';
import MonitorIcon from '../components/MonitorIcon';
import SlackBubble from '../components/Chatbot/SlackBubble';
import SlackMessage from '../components/Chatbot/SlackMessage';

// eslint-disable-next-line no-unused-vars
export default function ChatbotScreen({ route, navigation }: RootTabScreenProps<'HappyChat'>) {
  const [messages, setMessages] = useState([
    {
      _id: 1,
      text: 'How can I help?',
      createdAt: new Date(),
      user: {
        _id: 2,
        name: 'Here Works',
        // avatar: '/assets/hw-logo.png',
      },
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [chatTitle, setChatTitle] = useState('New Conversation');
  const [screenType, setScreenType] = useState('');
  const [inputText, setInputText] = useState('');
  const [range, setRange] = useState<{
        start: Date | undefined;
        end: Date | undefined;
        }>({ start: null, end: null });
  const [metric, setMetric] = useState('');
  const [title, setTitle] = useState('');
  const [label, setLabel] = useState('');
  const [displayText, setDisplayText] = useState('Ask me to plot something!');
  const [room, setRoom] = useState(null);
  const [metricTwo, setMetricTwo] = useState('');
  const [titleTwo, setTitleTwo] = useState('');
  const [numLines, setNumLines] = useState(0);
  const [compareRange, setCompareRange] = useState<{
        start: Date | undefined;
        end: Date | undefined;
        }>({ start: null, end: null });

  const onSendPlot = async () => {
    const client = await AsyncStorage.getItem('clientName');
    try {
      const response = await fetch('https://api-v2-dev.hereworks.tech/hw-chatbot/plot', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_question: inputText,
          client,
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const replyData = await response.json();
      setRange({ start: replyData.dates.min, end: replyData.dates.max });
      setCompareRange({ start: replyData.compareDates.min, end: replyData.compareDates.max });
      setMetric(replyData.indexNames[0]);
      setTitle(replyData.Fields[0]);
      setLabel(replyData.Titles[0]);
      setRoom(replyData.Rooms[0]);
      setNumLines(replyData.numPlots);
      if (replyData.numPlots > 1) {
        setMetricTwo(replyData.indexNames[1]);
        setTitleTwo(replyData.Fields[1]);
      }
      if (replyData.Error) {
        // setIsError(true);
        setDisplayText(replyData.Error);
      } else {
        // (false);
        setDisplayText(replyData.Title);
      }
      setInputText('');
    } catch (error) {
      console.error('Error during fetch:', error);
    }
  };

  const renderPlot = () => {
    if (numLines === 2) {
      return (
      <View style={{ flex: 1 }}>
          <Text style={styles.cardHeader}>{displayText}</Text>
          <BarWithLineGraphWeb
              dates={range}
              compareDates={compareRange}
              metric={metric}
              title={title}
              prevMetric={metricTwo}
              prevTitle={titleTwo}
              compareToggled={compareRange.end !== null}
          />
      </View>
      );
    }
    if (numLines === 1) {
      return (
      <View style={{ flex: 1 }}>
          <Text style={styles.cardHeader}>{displayText}</Text>
          <CompareLineGraphWeb
              dates={range}
              compareDates={compareRange}
              metricName={metric}
              unit={title}
              title={label}
              compareToggled={compareRange.end !== null}
              thingRoom={room}
          />
      </View>
      );
    }
    return (
      <View style={{ flex: 1 }}>
          <Text style={styles.cardHeader}>{displayText}</Text>
      </View>
    );
  };

  // const onNewSessionPress = async () => {
  //   try {
  //     const response = await fetch('https://llm.hereworks.tech/endConv', {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }
  //   } catch (error) {
  //     console.error('Error during fetch:', error);
  //   }

  //   try {
  //     const response = await fetch('https://llm.hereworks.tech/startConv', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         client: 'mastercard',
  //       }),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }
  //     setChatTitle('New Conversation');

  //     setMessages([
  //       {
  //         _id: Math.random(),
  //         text: 'Hello! How may I help you?',
  //         createdAt: new Date(),
  //         user: {
  //           _id: 2,
  //           name: 'Here Works',
  //           // avatar: '/assets/hw-logo.png',
  //         },
  //       },
  //     ]);
  //   } catch (error) {
  //     console.error('Error during fetch:', error);
  //   }
  // };

  const onSendChat = useCallback(async (newMessages = []) => {
    const client = await AsyncStorage.getItem('clientName');
    console.log(client);
    // User's message
    setMessages((previousMessages) => GiftedChat.append(previousMessages, newMessages));

    setIsLoading(true);
    // Call the external program/API

    if (chatTitle === 'New Conversation') {
      setChatTitle(newMessages[0].text);
    }

    try {
      const response = await fetch('https://api-v2-dev.hereworks.tech/hw-chatbot/respond', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_question: newMessages[0].text,
          client,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const replyData = await response.json();

      // Automatically reply with the external program's response
      const replyMessage = {
        _id: Math.random(),
        text: replyData.response,
        createdAt: new Date(),
        user: {
          _id: 2, // Bot's user id
          name: 'Here Works',
          // avatar: '/assets/hw-logo.png',
        },
      };

      setIsLoading(false);
      setMessages((previousMessages) => GiftedChat.append(previousMessages, [replyMessage]));
    } catch (error) {
      console.error('Error during fetch:', error);
    }
  }, []);

  const renderBubble = (props) => <SlackBubble {...props}/>;

  const renderFooter = () => {
    if (isLoading) {
      return (
        <View style={styles.footerContainer}>
          <TypingAnimation
            dotColor='gray'
            dotMargin={5}
            dotAmplitude={5}
            dotSpeed={0.15}
            dotRadius={5}
            dotX={20}
            dotY={20}
          />
        </View>
      );
    }
    return null;
  };

  const renderInputToolbar = (props) => {
    const { onSend } = props;

    return (
      <InputToolbar
        {...props}
        textInputProps={{
          ...props.textInputProps,
          returnKeyType: 'send',
          multiline: false,
          onSubmitEditing: (event) => {
            const { text } = event.nativeEvent;
            if (text.trim().length > 0) {
              if (onSend) {
                onSend({ text: text.trim(), user: { _id: 1 } }, true);
              } else {
                console.error('onSend is undefined');
              }
            }
          },
          blurOnSubmit: false,
        }}
        containerStyle={{
          borderRadius: 10,
          borderTopWidth: 0,
          padding: 4,
          backgroundColor: 'white',
        }}
        primaryStyle={{ alignItems: 'center' }}
      />
    );
  };

  const renderComposer = (props) => (
      <Composer
        {...props}
        textInputProps={{
          ...props.textInputProps,
          returnKeyType: 'send',
          multiline: false, // Ensure single-line input
          // Handle onSubmitEditing if you want to send the message on return key press
        }}
        placeholder={'Ask a question'}
        textInputStyle={{
          flex: 1,
          flexDirection: 'row',
          borderRadius: 10,
          borderWidth: 1,
          borderColor: '#E8E8E8',
          paddingTop: 8.5,
          paddingBottom: 8.5,
          paddingHorizontal: 12,
          marginRight: 10,
          lineHeight: 28,
          fontSize: 16,
          justifyContent: 'center',
        }}
      />
  );

  const renderSend = (props) => {
    const isTextEmpty = !props.text || props.text.trim().length === 0;

    return (
      <Send
        {...props}
        containerStyle={{
          width: 44,
          height: 44,
          alignItems: 'center',
          justifyContent: 'center',
          marginHorizontal: 10,
          backgroundColor: isTextEmpty ? '#B6B9BC' : '#0058AD',
          borderRadius: 10,
          borderColor: 'white',
        }}
        disabled={isTextEmpty} // Disable the send button if there's no text
        alwaysShowSend
      >
        <FontAwesome
          size={20}
          style={{ color: '#fff' }}
          name={'send'}
        />
      </Send>
    );
  };

  if (screenType === '') {
    return <View style={{ flex: 1 }}>
      <Text
        style={{
          fontSize: 32,
          fontFamily: 'Poppins_400Regular',
          marginLeft: 40,
          marginTop: 40,
        }}
      >What do you want to do?</Text>
      <View style={{ flexDirection: 'row', marginHorizontal: 28 }}>
        <Pressable
          style={(state) => [styles.button, { backgroundColor: state.hovered ? Colors.light.hereworksBlue100 : '#fff' }]}
          onPress={() => setScreenType('chat')}>
            <View style={styles.icon}>
              <BotIcon color={'#fff'} />
            </View>
          <Text style={styles.buttonText}>ChatBot</Text>
        </Pressable>
        <Pressable
          style={(state) => [styles.button, { backgroundColor: state.hovered ? Colors.light.hereworksBlue100 : '#fff' }]}
          onPress={() => setScreenType('plot')}>
            <View style={styles.icon}>
              <MonitorIcon color={'#fff'} />
            </View>
          <Text style={styles.buttonText}>Plotting Visuals</Text>
        </Pressable>
      </View>
    </View>;
  }

  return screenType === 'chat' ? (
    <View
      style={{
        backgroundColor: Colors.light.hereworksBackground,
        flex: 1,
        padding: 12,
      }}
    >
      <View style={{
        flexDirection: 'row', alignItems: 'center', marginTop: 48, marginBottom: 32,
      }}>
        <Pressable
          style={{
            marginLeft: 10,
          }}
          onPress={() => setScreenType('')}>
          <BackArrow />
        </Pressable>
        <Text
          style={{
            fontSize: 22,
            lineHeight: 33,
            marginLeft: 10,
            fontFamily: 'Poppins_400Regular',
            color: Colors.light.hereworksBlack600,
            flex: 1,
          }}
        >
          Chat bot
        </Text>
      </View>
      <View
        style={{
          backgroundColor: '#fff',
          borderRadius: 20,
          borderWidth: 1,
          flex: 1,
          marginHorizontal: 12,
          marginBottom: 14,
          padding: 16,
          borderColor: Colors.light.hereworksBlue500,
          overflow: 'hidden',
        }}
      >
        <GiftedChat
          messages={messages}
          onSend={onSendChat}
          user={{
            _id: 1,
            name: 'User',
          }}
          isTyping={isLoading}
          renderBubble={(props) => renderBubble(props)}
          renderAvatar={(props) => <Avatar {...props} />}
          renderMessage={(props) => <SlackMessage {...props}/>}
          renderUsernameOnMessage
          renderFooter={renderFooter}
          renderInputToolbar={renderInputToolbar}
          renderComposer={renderComposer}
          renderSend={renderSend}
          alignTop={false}
        />
      </View>
    </View>
  ) : <ScrollView style={styles.container}>
  <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Pressable
          style={{
            marginLeft: 10,
          }}
          onPress={() => setScreenType('')}>
          <BackArrow />
      </Pressable>
      <Text
      style={{
        fontSize: 22,
        lineHeight: 33,
        marginLeft: 40,
        marginTop: 15,
        marginBottom: 15,
        fontFamily: 'Poppins_400Regular',
        color: Colors.light.hereworksBlack600,
        flex: 1,
      }}
      >
      Plotting Visuals
      </Text>
  </View>
  <View
      style={{
        backgroundColor: '#fff',
        borderRadius: 20,
        borderWidth: 1,
        flex: 1,
        marginHorizontal: 24,
        marginBottom: 24,
        borderColor: Colors.light.hereworksBlue500,
        overflow: 'hidden',
        maxWidth: 1200,
      }}
  >
  <View style={{
    flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: 10, borderBottomWidth: 1, borderBottomColor: Colors.light.hereworksBlue500,
  }}>
      <TextInput
      style={{
        flex: 1,
        flexDirection: 'row',
        borderRadius: 10,
        borderWidth: 1,
        borderColor: '#E8E8E8',
        paddingTop: 5,
        paddingBottom: 5,
        paddingHorizontal: 12,
        marginRight: 10,
        lineHeight: 22,
        fontSize: 14,
        justifyContent: 'center',
      }}
      onChangeText={(text) => setInputText(text)}
      value={inputText}
      placeholder="Enter Text"
      onSubmitEditing={() => onSendPlot()} // Call the send function when return key is pressed
      returnKeyType="send" // Optionally change the return key to indicate sending action
      blurOnSubmit={true}
      />
      <TouchableOpacity
      onPress={onSendPlot}
      style={{
        width: 35,
        height: 35,
        alignItems: 'center',
        justifyContent: 'center',
        marginHorizontal: 10,
        backgroundColor: '#0058AD',
        borderRadius: 10,
        borderColor: 'white',
      }}
      >
      <FontAwesome
          size={20}
          style={{ color: '#fff' }}
          name={'send'}
      />
      </TouchableOpacity>
      </View>
      { renderPlot() }
  </View>
  </ScrollView>;
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.light.hereworksBackground,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: Colors.light.hereworksBlue500,
  },
  headerButton: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 25,
    padding: 10,
    backgroundColor: Colors.light.hereworksBlue500,
    borderRadius: 5,
  },
  footerContainer: {
    marginTop: 5,
    marginLeft: 30,
    marginRight: 10,
    marginBottom: 40,
  },
  footerText: {
    fontSize: 40,
    color: Colors.light.hereworksPrimaryGrey,
  },
  button: {
    flex: 1,
    justifyContent: 'center',
    margin: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
  },
  buttonText: {
    fontSize: 20,
    margin: 24,
    marginTop: 50,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
  },
  icon: {
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.light.hereworksBlue500,
    borderRadius: 25,
    margin: 24,
  },
  cardHeader: {
    fontFamily: 'Poppins_400Regular',
    fontSize: 20,
    color: Colors.light.hereworksPrimaryGrey,
    marginLeft: 24,
    marginTop: 20,
    marginBottom: 5,
  },
});
